var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("h1", [_vm._v("Hello, world! " + _vm._s(_vm.currentcount))]),
    _vm._v(" "),
    _c("p", [
      _vm._v("Welcome to your new single-page application, built with:")
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("p", [_vm._v("To help you get started, we've also set up:")]),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [
        _c("a", { attrs: { href: "https://get.asp.net/" } }, [
          _vm._v("ASP.NET Core")
        ]),
        _vm._v(" and "),
        _c(
          "a",
          {
            attrs: {
              href: "https://msdn.microsoft.com/en-us/library/67ef8sbd.aspx"
            }
          },
          [_vm._v("C#")]
        ),
        _vm._v(" for cross-platform server-side code")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("a", { attrs: { href: "https://vuejs.org/" } }, [_vm._v("Vue.js")]),
        _vm._v(" and "),
        _c("a", { attrs: { href: "http://www.typescriptlang.org/" } }, [
          _vm._v("TypeScript")
        ]),
        _vm._v(" for client-side code")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("a", { attrs: { href: "https://webpack.github.io/" } }, [
          _vm._v("Webpack")
        ]),
        _vm._v(" for building and bundling client-side resources")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("a", { attrs: { href: "http://getbootstrap.com/" } }, [
          _vm._v("Bootstrap")
        ]),
        _vm._v(" for layout and styling")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Client-side navigation")]),
        _vm._v(". For example, click "),
        _c("em", [_vm._v("Counter")]),
        _vm._v(" then "),
        _c("em", [_vm._v("Back")]),
        _vm._v(" to return here.")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Webpack dev middleware")]),
        _vm._v(". In development mode, there's no need to run the "),
        _c("code", [_vm._v("webpack")]),
        _vm._v(
          " build tool. Your client-side resources are dynamically built on demand. Updates are available as soon as you modify any file."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Hot module replacement")]),
        _vm._v(
          ". In development mode, you don't even need to reload the page after making most changes. Within seconds of saving changes to files, your Vue app will be rebuilt and a new instance injected is into the page."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Efficient production builds")]),
        _vm._v(
          ". In production mode, development-time features are disabled, and the "
        ),
        _c("code", [_vm._v("webpack")]),
        _vm._v(" build tool produces minified static CSS and JavaScript files.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }